import moment from "moment";
import Lottie from "react-lottie";
import Badge from "../components/Badge";
import { Tooltip } from "react-tooltip";
import ApiServices from "../api/services";
import ReactPaginate from "react-paginate";
import Heading from "../components/Heading";
import Spinner from "../components/Spinner";
import Skeleton from "react-loading-skeleton";
import { images } from "../assets/styles/Images";
import { useMediaQuery } from "react-responsive";
import React, { useEffect, useState } from "react";
import ImagesModal from "../components/ImagesModal";
import RangePicker from "../components/RangePicker";
import DateRangePicker from "../components/DateRangePicker";
import FilterSelect from "../components/FilterSelect";
import EllipsisText from "../components/EllipsisText";
import StatusFilter from "../components/StatusFilter";
import TicketDetail from "../components/TicketDetail";
import { useLoggedContext } from "../context/provider";
import SupportFilter from "../components/SupportFilter";
import ReadMoreModal from "../components/ReadMoreModal";
import animationData from "../assets/lotties/empty-folder";
import ConfirmationModal from "../components/ConfirmationModal";
import SupportTicketComment from "../components/SupportTicketComment";
import { mediaUrl, ticketMediaUrl, userMediaUrl } from "../utils/config";
import { ArrowPathIcon, ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
const statusOption = [
  { label: "All", value: "All" },
  { label: "Opened", value: "Open" },
  { label: "Closed", value: "Closed" },
];

const SupportTicket = () => {
  // const todayStartDate = moment.utc().startOf("day");
  // const todayEndDate = moment.utc().endOf("day");

  // Context

  const { btnLoading, setBtnLoading, setLoading, user, getPendingSettingsGlobal } = useLoggedContext();

  const [isFocused, setIsFocused] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [replayText, setReplayText] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [allNursries, setAllNursries] = useState([]);
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(0);
  // const [ticketEndDate, setTicketEndDate] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [replayTextError, setReplayTextError] = useState("");
  // const [ticketStartDate, setTicketStartDate] = useState(null);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [previewReplyImages, setPreviewReplyImages] = useState([]);
  const [supportTicketsData, setSupportTicketsData] = useState([]);
  const [selectedReplyImages, setSelectedReplyImages] = useState([]);
  const [selectedTicketDetails, setSelectedTicketDetails] = useState(null);

  const [supportTicketsDataLoading, setSupportTicketsDataLoading] = useState(false);
  const [supportTicketsDetailLoading, setSupportTicketsDetailLoading] = useState(false);
  const [replyLoading, setReplyLoading] = useState(false);
  const [selectedStatusOption, setSelectedStatusOption] = useState(null);
  const [openImageModal, setOpenImageModal] = useState({ open: false, data: null });
  const [openReadMoreMessageModal, setOpenReadMoreMessageModal] = useState({ open: false, data: null });
  const [openCloseConfirmationModal, setOpenCloseConfirmationModal] = useState({ open: false });
  const [openTicketOpenConfirmationModal, setOpenTicketOpenConfirmationModal] = useState({ open: false });
  const [openCounts, setOpenCounts] = useState("");
  const [closeCounts, setCloseCounts] = useState("");

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  // const [dateRange, setDateRange] = useState({
  //   startDate: todayStartDate.unix(),
  //   endDate: todayEndDate.unix(),
  // });

  // Handle Select Images
  const handleReplyImageChange = (event) => {
    const files = event.target.files;
    // console.log({ files });

    if (files.length > 0) {
      const newImages = Array.from(files)?.map((file) => URL.createObjectURL(file));
      setPreviewReplyImages((prevImages) => [...prevImages, ...newImages]);

      const filesArray = Array.from(files);
      setSelectedReplyImages((prevImages) => [...prevImages, ...filesArray]);
    }
  };

  // Handle Cancel Selection
  const handleCancelSelection = (index) => {
    setPreviewReplyImages((prevImages) => prevImages?.filter((_, i) => i !== index));
    setSelectedReplyImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  // Handle Ticket Click
  const handleTicketClick = (ticketId) => {
    setSelectedTicketId(ticketId);
    getSupportTicketDetails(ticketId);
  };

  // Handle Image Click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setOpenImageModal({ open: true, data: null });
  };

  // Media Queries
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const isLaptop = useMediaQuery({ minWidth: 1024 });
  const isLaptopMedium = useMediaQuery({ minWidth: 1536 });
  const isLaptopLarge = useMediaQuery({ minWidth: 1599 });
  const isLargeScreenLaptop = useMediaQuery({ minWidth: 1700 });

  const itemsPerPage = isLargeScreenLaptop ? 2 : isLaptopMedium ? 2 : isLaptop ? 2 : 10;

  const shortDescription = isLargeScreenLaptop ? 700 : isLaptopLarge ? 600 : isLaptopMedium ? 500 : isLaptop ? 400 : isTablet ? 400 : 700;

  // Handle Change Pagination
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  // Get Support Tickets
  const getSupportTickets = async (sfilter, emptySearch) => {
    setSupportTicketsDataLoading(true);
    let payload = {
      search: emptySearch ? "" : searchText,
      page: currentPage,
      records_no: 2,
      start_date: dateRange.startDate ? dateRange.startDate : null,
      end_date: dateRange.startDate ? dateRange.endDate : null,
    };

    if (selectedFilter !== null && selectedFilter !== "All") {
      //localhost:3000/settings
      payload.setting = selectedFilter;
    }

    if (sfilter !== "All") {
      payload.status = sfilter;
    }

    const res = await ApiServices.supportTickets
      .getSupportTickets(payload)
      .then((res) => {
        const { data, message } = res;

        if (data.code === 200) {
          setSupportTicketsData(data?.data?.data);
          setCurrentPage(data?.data?.current_page);
          setTotalPageCount(Math.ceil(data?.data?.total / data?.data?.per_page));

          if (data?.data?.data && data?.data?.data.length > 0) {
            const firstTicketId = data?.data?.data[0].id;
            handleTicketClick(firstTicketId);
          }
          setSupportTicketsDataLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSupportTicketsDataLoading(false);
      });
  };

  // Get Ticket Detail
  const getSupportTicketDetails = (ticketId) => {
    // console.log("🚀 ~ getSupportTicketDetails ~ ticketId:", ticketId);
    setSupportTicketsDetailLoading(true);
    ApiServices.supportTickets
      .getSupportTicketsDetail(ticketId)
      .then((res) => {
        const { data, message } = res;
        if (data.code === 200) {
          setSelectedTicketDetails(data.data);
          setSupportTicketsDetailLoading(false);
        }
      })
      .catch((err) => {
        setSupportTicketsDetailLoading(false);
      });
  };

  // Get Support Ticket Counts
  const getSupportTicketCounts = async () => {
    try {
      // Assuming you have the start and end dates defined somewhere
      let payload = {
        // start_date: dateRange.startDate,
        // end_date: dateRange.endDate,
        setting: selectedFilter !== null && selectedFilter !== "All" ? selectedFilter : "",
      };

      // API call with dates
      const response = await ApiServices.supportTickets.getSupportTicketCounts(payload);

      // Process the response
      const responseData = response?.data;
      // console.log("responseData", responseData);

      if (responseData && responseData.code === 200) {
        setOpenCounts(responseData?.data?.open_count);
        setCloseCounts(responseData?.data?.closed_count);
      } else {
        // Handle errors or no data
        setOpenCounts(0);
        setCloseCounts(0);
      }
    } catch (error) {
      // Handle errors
      console.error("Error:", error);
      setOpenCounts(0);
      setCloseCounts(0);
    }
  };

  // console.log("openCounts==>", openCounts);
  // console.log("closeCounts==>", closeCounts);

  // Get Settings Without Pagination
  const getSettingsWithoutPagination = () => {
    ApiServices.supportTickets
      .getSettingsWithoutPagination()
      .then((res) => {
        const { data, message } = res;
        if (data.code === 200) {
          let settingsData = data?.data?.map((item) => ({
            image: mediaUrl + item.logo,
            label: item.name,
            value: item.name,
          }));

          settingsData = [{ image: "", label: "All", value: "All" }, ...settingsData];

          setAllNursries(settingsData);
        }
      })
      .catch((err) => {});
  };

  // Validations - Reply Text
  const validateReplayText = () => {
    if (!replayText.trim()) {
      setReplayTextError("Required");

      return false;
    }
    setReplayTextError("");
    return true;
  };

  // Update Ticket Status
  const updateTicketStatus = (status, callback) => {
    setBtnLoading(true);
    let id = selectedTicketDetails?.id;
    let payload = {
      status: status,
    };
    ApiServices.supportTickets
      .updateTicketStatus(id, payload)
      .then(({ data, message }) => {
        // callback(data);
        setBtnLoading(false);
        setShowMsgBox(false);
        getSupportTickets(selectedStatusOption?.value);
        getSupportTicketCounts();
        setSelectedReplyImages([]);
        setPreviewReplyImages([]);
        setReplayText("");
        setOpenCloseConfirmationModal({ open: false });
        setOpenTicketOpenConfirmationModal({ open: false });
      })
      .catch(({ response }) => {
        callback(response);
      });
  };

  // Handle Replay
  const handleReplay = () => {
    if (showMsgBox && replayText !== "") {
      const isReplayTextValid = validateReplayText();

      if (isReplayTextValid) {
        let id = selectedTicketDetails?.id;

        let formData = new FormData();
        formData.append("ticket_id", id);
        formData.append("response", replayText);
        selectedReplyImages.forEach((image, index) => {
          formData.append(`images[${index}]`, image);
        });
        setReplyLoading(true);

        ApiServices.supportTickets
          .updateSupportTicket(formData)
          .then((res) => {
            const { data, message } = res;

            if (data?.code === 200) {
              setReplyLoading(false);
              getSupportTicketDetails(id);

              setShowMsgBox(false);
              setReplayText("");
              if (isChecked) {
                updateTicketStatus("closed", (res) => {});
                setReplyLoading(false);
                getSupportTicketDetails(id);

                setShowMsgBox(false);
                setReplayText("");
              }
            } else {
            }
          })
          .catch((err) => {
            console.log("error update ticket", err);
            setReplyLoading(false);
          });
      }
    } else {
      setShowMsgBox(true);
    }
  };

  // Close Reply Box
  const handleCloseReplayBox = () => {
    setShowMsgBox(false);
    setReplayText("");
    setPreviewReplyImages(null);
  };

  // Handle Search
  const handleSearch = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (searchText.trim() !== "") {
        await getSupportTickets();
        setCurrentPage(1);
      }
    }
  };

  useEffect(() => {
    setSelectedTicketId(supportTicketsData[0]?.id);
  }, [supportTicketsData]);

  useEffect(() => {
    getSupportTickets(selectedStatusOption?.value);
  }, [currentPage, dateRange, selectedFilter, selectedStatusOption]);

  useEffect(() => {
    getSettingsWithoutPagination();
  }, [isFocused]);

  useEffect(() => {
    getSupportTicketCounts();
  }, [dateRange, selectedFilter]);

  useEffect(() => {
    getPendingSettingsGlobal();
  }, []);
  
  // Lottie Option
  const emptyFolderAnimation = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };

  // "super_panel_view_ticket",
  // "super_panel_response_ticket",
  // "super_panel_edit_delete_ticket",
  // "super_panel_change_status",

  return (
    <>
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
        <div className="card min-h-[85vh] space-y-4">
          <div className="flex justify-between">
            <div className="relative">
              <Heading
                heading="Tickets"
                subheading="Details of open & closed tickets."
                icon
                handleRefresh={() => {
                  getSupportTicketCounts();
                  getSupportTickets();
                  getSupportTicketDetails(selectedTicketDetails?.id);
                }}
              />
            </div>
            <div className="flex items-center gap-x-1">
              {/* <RangePicker setRangePicker={setDateRange} showDate width="3xl:w-80 2xl:w-60 xl:w-76" /> */}
              <DateRangePicker setRangePicker={setDateRange} rangePicker={dateRange} width="3xl:w-80 2xl:w-60 xl:w-76" />
              <div className="relative flex items-center w-40 3xl:w-auto">
                <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-4 pointer-events-none">
                  <MagnifyingGlassIcon className="w-5 h-5 text-primary-color-100" />
                </div>
                <input
                  type="search"
                  id="search"
                  name="search"
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    if (e.target.value.trim() === "") {
                      getSupportTickets(selectedStatusOption?.value, true);
                    }
                  }}
                  onKeyDown={handleSearch}
                  className="block w-full px-4 py-2 text-sm border rounded-full focus:ring-primary-color border-grayColor200 pl-11 text-primary-color-100 focus:border-primary-color-100"
                />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between border-b gap-x-4 ">
            <div className="flex items-center gap-x-3">
              <div className="flex">
                <img src={images.OpenTicketIcon} alt="open_ticket_icon" />
                <p className="text-sm text-primary-color-100">
                  <span className="pl-2 pr-1 text-sm font-semibold">{openCounts}</span>Open
                </p>
              </div>
              <div className="flex">
                <img src={images.CloseTicketIcon} alt="close_ticket_icon" />
                <p className="text-sm text-primary-color-100">
                  <span className="pl-2 pr-1 text-sm font-semibold">{closeCounts}</span>Closed
                </p>
              </div>
            </div>
            <div className="flex items-center gap-x-3">
              <SupportFilter
                options={allNursries}
                onSelect={(option) => {
                  setSelectedFilter(option.value);
                  // getSupportTicketCounts(option?.value);
                }}
              />
              <StatusFilter className="border-0" selected={selectedStatusOption} setSelected={setSelectedStatusOption} options={statusOption} />
            </div>
          </div>
          <div className="relative pt-4 pb-12 space-y-4 xl:pb-12 xl:pt-0">
            {supportTicketsDataLoading ? (
              <Skeleton count={itemsPerPage} height={200} />
            ) : supportTicketsData?.length > 0 ? (
              supportTicketsData?.map((item, index) => (
                <div key={index} onClick={() => handleTicketClick(item?.id)}>
                  <TicketDetail
                    activeColor={selectedTicketId === item.id ? "border-secondary" : "border-grayColor-200"}
                    heading={item?.title}
                    subheading={item?.description}
                    ticketNo={`#${item?.ticket_number}`}
                    status={item?.status}
                    date={moment.unix(item.unix_created_at).format("D MMM YYYY")}
                    dateWithTime={moment.unix(item.unix_created_at).format("D MMM YYYY h:mm A")}
                    companyIcon={mediaUrl + item?.user?.nursery[0]?.logo}
                    companyName={item?.user?.nursery[0]?.name}
                    comment={item?.response_count}
                  />
                </div>
              ))
            ) : (
              <div className="justify-cente flex h-[630px] items-center">
                <Lottie options={emptyFolderAnimation} height={200} width={200} />
              </div>
            )}
          </div>
          <div className="absolute bottom-4">
            <ReactPaginate
              breakLabel="..."
              pageRangeDisplayed={5}
              forcePage={currentPage - 1}
              marginPagesDisplayed={2}
              activeClassName="active"
              nextClassName="item next"
              renderOnZeroPageCount={null}
              breakClassName="item break-me "
              containerClassName="pagination"
              onPageChange={handlePageChange}
              previousClassName="item previous"
              pageClassName="item pagination-page "
              pageCount={totalPageCount}
              nextLabel={<ChevronRightIcon className="w-5 h-5" />}
              previousLabel={<ChevronLeftIcon className="w-5 h-5" />}
            />
          </div>
        </div>

        <div className="card min-h-[85vh]">
          {supportTicketsData?.length > 0 ? (
            <>
              {supportTicketsDetailLoading ? (
                <Skeleton count={1} height={250} />
              ) : selectedTicketDetails ? (
                <>
                  <div className="pb-4 space-y-3 border-b-2 border-grayColor200">
                    <div className="flex 2xl:gap-x-2">
                      <h2 className="text-lg font-semibold text-secondary-color 3xl:text-xl">{selectedTicketDetails?.title}</h2>
                      <span className="text-sm font-semibold text-grayColor400 3xl:text-base">{`#${selectedTicketDetails?.ticket_number || "0000"}`}</span>
                    </div>
                    <div className="flex items-center gap-x-2">
                      <Badge status={selectedTicketDetails?.status || "N/A"} />
                      <h2 className="text-xs text-primary-color-200 2xl:text-sm">
                        <span className="pr-1 font-medium">
                          <img
                            src={
                              selectedTicketDetails?.user?.nursery[0].logo
                                ? mediaUrl + "/" + selectedTicketDetails?.user?.nursery[0].logo
                                : images.placeholder
                            }
                            alt="Company"
                            className="inline-block w-6 h-6 rounded-full"
                          />{" "}
                          {selectedTicketDetails?.user?.nursery[0]?.name || "N/A"}
                        </span>
                        opened on
                        <span id="ticketdate" className="pl-1 font-medium">
                          {moment.unix(selectedTicketDetails?.created_at_unix).format("D MMM YYYY")}
                        </span>
                        <Tooltip
                          anchorSelect="#ticketdate"
                          id="ticketdate-tooltip"
                          offset={5}
                          className="border border-gray-100 !bg-white !text-primary-color-100 !opacity-100 shadow-card"
                          classNameArrow="hidden"
                          effect="solid"
                          place="bottom"
                        >
                          <span> {moment.unix(selectedTicketDetails?.created_at_unix).format("D MMM YYYY h:mm A")}</span>
                        </Tooltip>
                      </h2>
                    </div>
                    <div>
                      {/* <p className="text-sm font-inter text-grayColor400">{selectedTicketDetails?.description || "No Description Found"}</p> */}
                      <p className="text-sm font-inter text-grayColor400">
                        {selectedTicketDetails?.description?.length > shortDescription ? (
                          <div
                            className="cursor-pointer"
                            onClick={() => setOpenReadMoreMessageModal({ open: true, data: selectedTicketDetails?.description })}
                          >
                            <EllipsisText text={selectedTicketDetails?.description} maxLength={shortDescription} />
                          </div>
                        ) : (
                          <EllipsisText text={selectedTicketDetails?.description} maxLength={shortDescription} />
                        )}
                      </p>
                    </div>
                    <div className="relative grid grid-cols-12 gap-x-20">
                      {selectedTicketDetails?.images && selectedTicketDetails.images.length > 0 ? (
                        selectedTicketDetails.images
                          .filter((image) => image !== null)
                          .slice(0, 3)
                          .map((image, index) => (
                            <div
                              key={index}
                              className={`relative mx-auto h-16 w-16 cursor-pointer rounded-xl border border-grayColor200`}
                              onClick={() => handleImageClick(index)}
                            >
                              {image.endsWith(".pdf") ? (
                                <div className="flex items-center justify-center w-full h-full bg-gray-200 rounded-2xl">
                                  <span>
                                    <img src={images.PDF} className="w-16 h-16" alt="pdf-icon" />
                                  </span>
                                </div>
                              ) : (
                                <img src={ticketMediaUrl + "/" + image} className="object-cover w-full h-full rounded-2xl" alt={`Image ${index}`} />
                              )}
                              {index === 2 && selectedTicketDetails.images.length > 3 && (
                                <div className="absolute inset-0 flex items-center justify-center rounded-xl bg-black/50">
                                  <span className="text-xl font-bold text-white">{`+${selectedTicketDetails.images.length - 3}`}</span>
                                </div>
                              )}
                            </div>
                          ))
                      ) : (
                        <div>
                          <p>Images:</p>
                          <Lottie options={emptyFolderAnimation} height={100} width={100} />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Lottie options={emptyFolderAnimation} height={200} width={200} />
                  <p className="text-base font-medium text-center text-gray-400">Event Not Selected</p>
                </>
              )}
              <h2 className="py-3 text-xl font-semibold text-secondary-color">
                Comments <span>({selectedTicketDetails?.ticket_responses.length})</span>
              </h2>
              <div className="xxl:max-h-64 max-h-full space-y-3 overflow-y-auto pb-12 pr-3 xl:max-h-60 xl:pb-4 2xl:max-h-[24rem]  3xl:max-h-[45vh]">
                {supportTicketsDetailLoading ? (
                  <Skeleton count={1} height={250} />
                ) : selectedTicketDetails?.ticket_responses?.length > 0 ? (
                  selectedTicketDetails?.ticket_responses?.map((comment, index) => (
                    <SupportTicketComment
                      key={comment.id}
                      personImage={
                        comment?.user?.nursery?.length > 0 && comment?.user?.nursery[0]?.logo !== null
                          ? mediaUrl + comment?.user?.nursery[0]?.logo
                          : comment?.user?.employee[0]?.profile_image_url !== null
                            ? userMediaUrl + comment?.user?.employee[0]?.profile_image_url
                            : images.placeholder
                      }
                      personName={comment?.user?.nursery?.length > 0 ? comment?.user?.nursery[0]?.name : comment?.user?.employee[0]?.name}
                      personStatus={comment?.response_by_tag}
                      commentDate={moment.unix(comment?.created_at_unix).format("D MMM YYYY")}
                      tooltipDate={moment.unix(comment?.created_at_unix).format("D MMM YYYY h:mm A")}
                      commentMsg={comment?.response}
                      commentImage={comment?.images}
                      selectedTicketDetail={selectedTicketDetails}
                      commentIndex={index}
                    />
                  ))
                ) : (
                  <Lottie options={emptyFolderAnimation} height={200} width={200} />
                )}
                <div className="!-mb-2 flex w-full items-center justify-center">
                  {selectedTicketDetails?.closed_by && <div className={`h-[1px] w-full bg-grayColor200`}></div>}
                  <>
                    {selectedTicketDetails?.status === "Closed" && (
                      <div className="w-full">
                        <div className="ml-5 text-sm text-grayColor400">
                          <span>Closed by </span>
                          <span className="text-sm font-medium text-grayColor300">
                            {" "}
                            {selectedTicketDetails?.closed_by?.employee.length > 0
                              ? selectedTicketDetails?.closed_by?.employee[0]?.name
                              : selectedTicketDetails?.closed_by?.nursery[0]?.name}
                          </span>
                          <span> at </span>
                          <span>{moment.unix(selectedTicketDetails?.updated_at_unix).format("D MMM YYYY h:mm A")}</span>
                        </div>
                      </div>
                    )}
                  </>
                </div>
              </div>
              <div
                className={`absolute bottom-0 left-0   flex w-full flex-col justify-end ${showMsgBox ? "rounded-20" : "rounded-b-20"}  bg-white px-6 py-3 shadow-card-bottom 3xl:py-4`}
              >
                {showMsgBox && (
                  <div className="w-full py-2">
                    <textarea
                      type="text"
                      rows={3}
                      value={replayText}
                      onChange={(e) => setReplayText(e.target.value)}
                      className="w-full border-0 rounded-lg outline-none placeholder:text-primary-color-100 "
                      placeholder="Enter your response..."
                    />
                    <div className={`flex items-center  ${previewReplyImages ? "justify-between" : "justify-end"}`}>
                      {previewReplyImages && (
                        <div className="flex flex-wrap gap-2">
                          {previewReplyImages.map((image, index) => (
                            <div key={index} className="relative w-12 h-12 cursor-pointer">
                              {/* {console.log({ image })} */}
                              <div
                                className="absolute top-0 right-0 flex items-center w-4 h-4 bg-white rounded-full shadow-tool-tip"
                                onClick={() => handleCancelSelection(index)}
                              >
                                <XMarkIcon className="w-4 h-4 text-black" />
                              </div>
                              {selectedReplyImages[index].type === "image/jpeg" || selectedReplyImages[index].type === "image/png" ? (
                                <img src={image} alt={`Selected Image ${index}`} className="w-full h-full rounded-sm" />
                              ) : (
                                <div className="flex items-center justify-center w-full h-full bg-gray-200 rounded-sm">
                                  <span>
                                    <img src={images.PDF} className="w-8 h-8" alt="pdf-icon" />
                                  </span>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}

                      {/* {previewReplyImages && (
                        <div className="flex flex-wrap gap-2">
                          {previewReplyImages.map((image, index) => (
                            <div key={index} className="relative w-12 h-12 cursor-pointer">
                              {console.log({image})}
                              <div
                                className="absolute top-0 right-0 flex items-center w-4 h-4 bg-white rounded-full shadow-tool-tip"
                                onClick={() => handleCancelSelection(index)}
                              >
                                <XMarkIcon className="w-4 h-4 text-black" />
                              </div>
                              <img src={image} alt={`Selected Image ${index}`} className="w-full h-full rounded-sm" />
                            </div>
                          ))}
                        </div>
                      )} */}

                      <div className="flex flex-col gap-y-2">
                        {/* {showToolTip && <div className="p-2 bg-white rounded-lg text-primary-color-100 shadow-tool-tip">Upload Attachments</div>} */}

                        <div className="self-end">
                          <label htmlFor="attachments" id="attachment">
                            <img src={images.Attachments} alt="Attachments" style={{ cursor: "pointer" }} />
                          </label>
                          <input
                            type="file"
                            multiple
                            name="attachments"
                            id="attachments"
                            style={{ display: "none" }}
                            accept="image/*,.pdf"
                            onChange={handleReplyImageChange}
                          />
                        </div>
                        <Tooltip
                          anchorSelect="#attachment"
                          id="attachment-tooltip"
                          offset={5}
                          className="border border-gray-100 !bg-white !text-primary-color-100 !opacity-100 shadow-card"
                          classNameArrow="hidden"
                          effect="solid"
                          place="top-start"
                        >
                          {/* Tooltip Content */}
                          <span>Upload Attachments</span>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                )}
                {(user?.permissions?.includes("super_panel_response_ticket") || user?.role === "super_admin") && (
                  <div className={`flex items-center  ${showMsgBox ? "justify-between border-t-2 border-grayColor200 pt-3" : "justify-end"}`}>
                    {showMsgBox && (
                      <>
                        <div className="flex items-center gap-x-1">
                          <input
                            type="checkbox"
                            id="remember"
                            name="remember"
                            className="rounded-sm"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)}
                          />
                          <label for="remember" className="font-medium label ps-2 text-primary-color-200">
                            Mark <span className="font-semibold">{`#${selectedTicketDetails?.ticket_number || "##"}`}</span> as{" "}
                            <span className="text-red-500">Closed</span>
                          </label>
                        </div>
                      </>
                    )}

                    {selectedTicketDetails?.status === "Closed" ? (
                      <button
                        className="px-12 py-2 text-sm text-white rounded-full bg-accent 3xl:text-base"
                        type="button"
                        onClick={() => setOpenTicketOpenConfirmationModal({ open: true })}
                      >
                        Re-open
                      </button>
                    ) : (
                      <>
                        <div>
                          {showMsgBox && (
                            <button
                              onClick={handleCloseReplayBox}
                              className="px-12 py-2 text-sm rounded-full text-secondary 3xl:text-base "
                              type="button"
                            >
                              Cancel
                            </button>
                          )}

                          {selectedTicketDetails?.status === "Open" && !showMsgBox && (
                            <button
                              onClick={() => setOpenCloseConfirmationModal({ open: true })}
                              className="px-6 py-2 text-sm font-medium text-red-500 rounded-full 3xl:text-base "
                              type="button"
                            >
                              Close Ticket
                            </button>
                          )}

                          {supportTicketsData?.length > 0 ? (
                            <button
                              onClick={handleReplay}
                              className="px-12 py-2 text-sm text-white rounded-full bg-secondary 3xl:text-base "
                              type="button"
                            >
                              {replyLoading ? <Spinner /> : "Reply"}
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center h-full justify-cente">
                <Lottie options={emptyFolderAnimation} height={200} width={200} />
              </div>
            </>
          )}
        </div>
      </div>
      <ImagesModal
        // images={selectedTicketDetails?.images
        //   .filter((imageUrl) => imageUrl !== null)
        //   .map((imageUrl) => ({
        //     original: ticketMediaUrl + "/" + imageUrl,
        //     thumbnail: ticketMediaUrl + "/" + imageUrl,
        //   }))}

        imagespdf={selectedTicketDetails?.images?.map((imageUrl) => ({
          original: ticketMediaUrl + "/" + imageUrl,
          thumbnail: ticketMediaUrl + "/" + imageUrl,
        }))}
        images={selectedTicketDetails?.images?.map((imageUrl) => ({
          original: imageUrl.endsWith(".pdf") ? ticketMediaUrl + "/" + imageUrl : ticketMediaUrl + "/" + imageUrl,
          thumbnail: imageUrl.endsWith(".pdf") ? images.PDF : ticketMediaUrl + "/" + imageUrl,
        }))}
        isOpen={openImageModal.open}
        setIsOpen={(isOpen) => setOpenImageModal({ ...openImageModal, open: isOpen })}
        selectedImageIndex={selectedImageIndex}
      />

      <ReadMoreModal
        data={openReadMoreMessageModal.data}
        isOpen={openReadMoreMessageModal.open}
        setIsOpen={(isOpen) => setOpenReadMoreMessageModal({ ...openReadMoreMessageModal, open: isOpen })}
        name="Support Ticket Description"
      />

      <ConfirmationModal
        isOpen={openCloseConfirmationModal.open}
        setIsOpen={(isOpen) => setOpenCloseConfirmationModal({ ...openCloseConfirmationModal, open: isOpen })}
        handleSubmit={() => updateTicketStatus("closed")}
        label="Close"
        labelTwo="the ticket"
      />

      <ConfirmationModal
        isOpen={openTicketOpenConfirmationModal.open}
        setIsOpen={(isOpen) => setOpenTicketOpenConfirmationModal({ ...openTicketOpenConfirmationModal, open: isOpen })}
        handleSubmit={() => updateTicketStatus("open")}
        label="Re-open"
        labelTwo="the ticket"
      />
    </>
  );
};

export default SupportTicket;
